<template>
    <div id="app" :class="{ 'app' : true, 'non-fiction' : $route.path.includes('insight') }">
        <hb-loader />
        <!-- <non-fiction-empty-navbar v-if="emptyNavbarRoute" />
        <non-fiction-nav-bar /> -->

        <notifications group="app-notifications" />
        <nonfiction-player-container />
        <transition name="slide-up" mode="in-out">
            <reader-mode
                v-show="showReaderMode"
                @close-reader-mode="closeReaderMode"
            />
        </transition>
        <transition name="fade" mode="out-in">
            <router-view class="content" />
        </transition>
    </div>
</template>

<script>

import _isEmpty from "lodash/isEmpty";
import { mapState, mapGetters } from "vuex";
import metaInfoMixins from "@/mixins/metaInfoMixins";

export default {
    name: "App",
    components: {
        hbLoader: () => import(/* webpackChunkName: "hb-fullscreen-loader"*/ "@c/fullscreen-loader.vue"),
        // nonFictionEmptyNavbar: () => import(/* webpackChunkName: "empty-navbar"*/ "@c/navbar/empty-navbar.vue"),
        readerMode: () => import(/* webpackChunkName: "reader-mode"*/ "@c/reader-mode/index"),
        nonfictionPlayerContainer: () => import(/* webpackChunkName: "audio-player-container"*/ "@c/audio-player/player-container.vue")
    },
    mixins: [metaInfoMixins],
    computed: {
        ...mapState({
            showReaderMode: state => state.NonfictionReader.showReaderMode,
            profileGroup: state => state.Application.profileGroup
        }),
        ...mapGetters({
            userIsReady: "User/userIsReady",
            isLoggedIn: "User/isLoggedIn"
        }),
        emptyNavbarRoute() {
            const emptyNavbarRoutes = [
                "bi-campaigns-landing-full",
                "bi-campaigns-landing-short",
                "start-for-free"
            ];

            return emptyNavbarRoutes.includes(this.$route.name);
        }
    },
    watch: {
        "$route": {
            handler({ params }) {
                if (!_isEmpty(params.notification) && params.notification.group != "profile-notifications") {
                    this.showNotification(params.notification);
                }
            },
            immediate: true
        },
        userIsReady(current, oldVal) {
            if (!current && current !== oldVal) {
                this.logoutHandler();
            }
        }
    },
    mounted() {
        if (process.env.NODE_ENV === "production") {
            this.initLeanplum();
        }
    },
    methods:{
        showNotification(notification = {}) {
            this.$nextTick(() => {
                this.$notify({
                    group: "app-notifications",
                    type: "success",
                    text: "",
                    duration: 5000,
                    ...notification
                });
            });
        },
        closeReaderMode() {
            this.$store.dispatch("NonfictionReader/setShowReaderMode", false);
        },
        logoutHandler() {
            if (!_isEmpty(this.$route.meta)) {
                if (this.$route.meta.requiresAuth) {
                    this.$router.push({ name: "bi-discover" })
                }
            }
        },
        initLeanplum() {
            if (process.env.NODE_ENV === "production") {
                Leanplum.setAppIdForProductionMode(process.env.VUE_APP_LEAM_PLUM_APP_ID, process.env.VUE_APP_LEAN_PLUM_PUBLIC_KEY);
            } else {
                Leanplum.setAppIdForDevelopmentMode(process.env.VUE_APP_LEAM_PLUM_APP_ID, process.env.VUE_APP_LEAN_PLUM_PUBLIC_KEY);
            }

            Leanplum.start((success) => {
                console.log("Success: " + success);
            });
        }
    }
}
</script>

<style lang="scss">
.fixed-navbar {
    position: fixed !important;
    top: 0;
}
</style>
